
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sms",
      function () {
        return require("private-next-pages/sms/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sms"])
      });
    }
  